// extracted by mini-css-extract-plugin
export default {"TopNavMenuItem":"TopNav_TopNavMenuItem__Qda8p"};